import {Component, Input, OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {DataType, Header, SortableTableComponent} from '../../components/helpers/sortableTable/sortableTable.component';
import {Level, ToastService} from '../../services/toast.service';
import {StudentService} from '../../services/student.service';
import {NgForm} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {EvidenceDto} from '@sidr/dto-types';

@Component({
  selector: 'app-student-runningrecord',
  templateUrl: './student-runningrecord.component.html',
  styleUrls: ['./student-runningrecord.component.scss']
})
export class StudentRunningRecordComponent implements OnChanges {
  loading: boolean;
  @Input() districtId: string;
  @Input() studentId: string;
  @Input() printOptions: PrintOptions;

  keepModalOpen = true;
  notificationTitle = 'Evidence';
  maxDate: string;
  evidence: EvidenceDto[];
  evidenceModal: EvidenceDto;

  @ViewChild(SortableTableComponent) public Table: SortableTableComponent;
  headers: Header[];

  newBhvr(): EvidenceDto {
    let evidenceModal = {
      date: '',
      concern: '',
      evidence: '',
      importTag: ''
    };
    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    evidenceModal.date = `${now.getFullYear()}-${month}-${day}`;

    return evidenceModal;
  }

  constructor(
    private studentService: StudentService,
    private toastService: ToastService,
    private modalService: NgbModal) {
    this.loading = false;
    this.evidence = [];
    this.evidenceModal = this.newBhvr();

    this.headers = [];
    this.headers.push(new Header('Date', 'date', false, DataType.Date, {dateFormat: 'shortDate'}));
    this.headers.push(new Header('Concern', 'concern', false, DataType.String));
    this.headers.push(new Header('Evidence', 'evidence', false, DataType.String));

    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    this.maxDate = `${now.getFullYear()}-${month}-${day}`;
  }

  getData() {
    if (!this.districtId || !this.studentId) {
      return;
    }
    this.loading = true;
    this.studentService.getEvidence(this.districtId, this.studentId).subscribe(r => {
      this.loading = false;
      this.evidence = r || [];
    }, (err) => {
      this.loading = false;
      this.toastService.AddNotification(Level.ERROR, this.notificationTitle, err.message);
    });
  }

  save(d: EvidenceDto, form: NgForm) {
    this.loading = true;
    (d.id && d.id.length > 0 ?
      this.studentService.patchEvidence(this.districtId, this.studentId, d) :
      this.studentService.postEvidence(this.districtId, this.studentId, d))
    .subscribe(resp => {
      this.toastService.AddNotification(Level.SUCCESS, this.notificationTitle, 'Record saved successfully');
      this.getData();
      this.Table.clear();
      if (d.id && d.id?.length > 0 || !this.keepModalOpen) {
        this.modalService.dismissAll();
      }
      this.evidenceModal = this.newBhvr();
    }, err => {
      this.toastService.AddNotification(Level.ERROR, this.notificationTitle, 'Error saving record');
    }, () => {
      this.loading = false;
    });
  }

  del(d: EvidenceDto) {
    this.loading = true;
    this.studentService.deleteEvidence(this.districtId, this.studentId, d.id!).subscribe(resp => {
      this.loading = false;
      this.getData();
    });
  }

  ngOnChanges() {
    this.getData();
  }

  newRecord(content: TemplateRef<any>) {
    this.evidenceModal = {
      date: '',
      concern: '',
      evidence: '',
      importTag: ''
    };
    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    this.evidenceModal.date = `${now.getFullYear()}-${month}-${day}`;
    this.modalService.open(content, {centered: true});
  }

  edit($event: EvidenceDto, content: TemplateRef<any>) {
    this.evidenceModal = {...$event};
    this.modalService.open(content, {centered: true});
  }
}
